import type { OnboardingAnswers } from '~/types/onboarding';

/**
 * Pardot form-handler field names (external). Values are taxonomy / technical
 * keys — never localized labels. `applications` is an array so the formhandler
 * can POST repeated keys (`applications=a&applications=b`).
 */
export type PardotOnboardingPayload = {
  email: string;
  industry?: string;
  applications?: string[];
  business?: string;
  phase?: string;
  jobfunction?: string;
};

/**
 * Maps local onboarding answers to the Pardot form-handler payload.
 * Omits unanswered fields.
 */
export function mapAnswersToPardotPayload(
  answers: OnboardingAnswers,
  email: string
): PardotOnboardingPayload {
  const payload: PardotOnboardingPayload = { email };

  if (answers.industryId) {
    payload.industry = answers.industryId;
  }

  if (answers.applicationIds.length > 0) {
    payload.applications = [...answers.applicationIds];
  }

  if (answers.customerGroupId) {
    payload.business = answers.customerGroupId;
  }

  if (answers.buyingJourneyPhase) {
    payload.phase = answers.buyingJourneyPhase;
  }

  if (answers.jobPositionId) {
    payload.jobfunction = answers.jobPositionId;
  }

  return payload;
}
